var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPilihMakanan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 314,
    viewBox: "0 0 260 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 314,
    rx: 6,
    fill: "#F5F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 96.3635,
    height: 77.027,
    rx: 6,
    fill: "#71A7F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 111.297,
    width: 96.3635,
    height: 7.7027,
    rx: 3.85135,
    fill: "#71A7F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 139.637,
    y: 24,
    width: 96.3635,
    height: 77.027,
    rx: 6,
    fill: "#71A7F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.637,
    y: 111.297,
    width: 96.3635,
    height: 7.7027,
    rx: 3.85135,
    fill: "#71A7F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 143,
    width: 96.3635,
    height: 77.027,
    rx: 6,
    fill: "#71A7F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 230.297,
    width: 96.3635,
    height: 7.7027,
    rx: 3.85135,
    fill: "#71A7F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 139.637,
    y: 143,
    width: 96.3635,
    height: 77.027,
    rx: 6,
    fill: "#71A7F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 139.637,
    y: 230.297,
    width: 96.3635,
    height: 7.7027,
    rx: 3.85135,
    fill: "#71A7F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 262,
    width: 91,
    height: 20,
    rx: 6,
    fill: "#71A7F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilihMakanan);
export default __webpack_public_path__ + "static/media/pilihMakanan.dba2ca6dc2d29d00b76643401d53d4a3.svg";
export { ForwardRef as ReactComponent };